import type { List } from 'immutable';
import { createSelector } from 'reselect';
import type SavedFilterRecord from '~/ducks/machine-filter-v2/data/SavedFilterRecord';
import type MachineFilterStateRecord from '~/ducks/machine-filter-v2/reducer/MachineFilterStateRecord';
import type { FilterTypes } from '~/ducks/machine-filter-v2/types/filter-value-types';

export const getFilters = (machineFilterV2: MachineFilterStateRecord) =>
  machineFilterV2.getFilters() as List<FilterTypes>;

const getSavedFilters = (machineFilterV2: MachineFilterStateRecord) => machineFilterV2.savedFilters;

const sortByIsFavoriteAndName = (a: SavedFilterRecord, b: SavedFilterRecord) => {
  if (a.favorite && b.favorite) {
    return a.name.localeCompare(b.name);
  }
  if (a.favorite) {
    return -1;
  }
  if (b.favorite) {
    return 1;
  }
  return 0;
};

export const getSortedFavoriteFilters = createSelector(getSavedFilters, (savedFilters) => {
  return savedFilters.filter((f) => f.favorite).sort(sortByIsFavoriteAndName);
});
